import { Row } from "antd";
import { useSelector } from "react-redux";

export const TimeZone = () => {
  const metaData = useSelector((state: any) => state.metaData);

  return (
    <Row className="d-block info">
      <p className="mt-0 mb-1 text title">Time Zone</p>
      <p className="text ls-5 my-0 elipsis">{metaData.timeZoneDisplayName}</p>
    </Row>
  );
};
